import { render, staticRenderFns } from "./taskDetial.vue?vue&type=template&id=48d93b12&scoped=true&"
import script from "./taskDetial.vue?vue&type=script&lang=js&"
export * from "./taskDetial.vue?vue&type=script&lang=js&"
import style0 from "./taskDetial.vue?vue&type=style&index=0&id=48d93b12&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d93b12",
  null
  
)

export default component.exports